export enum POG_POPUP_TYPE{
    EMBEDDED_MODAL=1,
    MODAL,
    NOTIFY
}